import { render, staticRenderFns } from "./DailyQuiz.vue?vue&type=template&id=2eac198e&"
import script from "./DailyQuiz.vue?vue&type=script&lang=js&"
export * from "./DailyQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports